<template>
  <main id="about-page">
    <ContentTitle
      :category="$t('sideMenu.Firmware')"
      :categoryIcon="'scf-traced'"
      :title="$t('sideMenu.FirmwareAdd')"
    /><br /><br />
    <div class="row">
      <div class="col-sm-1"></div>
      <div class="col-sm-10" @click="inputFileClickEvent">
        <div class="input-group mb-3">
          <div class="input-group-text custom-file-input-group">
            <button type="submit" class="btn-primary2 mb-2">
              <!-- <img src="../assets/icons/Stroke.png" class="icontitle" /> -->
              <i
                class="scf-dSquare"
                style="
                  margin-right: 10px;
                  left: 5px;
                  width: 16px;
                  /* height: 16px; */
                  /* top: 4.5px; */
                "
              />
              {{ this.$t("pages.FirmwareAdd.ChooseFile") }}
            </button>
          </div>
          <input
            type="text"
            class="form-control txtAreaChoose"
            id="inputPassword"
            v-model="filename"
            readonly
            :placeholder="this.$t('pages.FirmwareAdd.ChooseFile')"
          />
          <div hidden>
            <input
              class="form-control"
              type="file"
              ref="file"
              @change="selectFile"
              style="font-style: italic"
              accept="application/x-zip-compressed"
            />
          </div>
        </div>
      </div>
      <!-- <div
        class="col-sm-2 d-sm-flex justify-content-sm-end"
        @click="inputFileClickEvent"
      >
        <button type="submit" class="btn-primary2 mb-2">
          <img src="../assets/icons/Stroke.png" class="icontitle" />
          <i
            class="scf-dSquare"
            style="
              margin-right: 10px;
              left: 5px;
              width: 16px;
              /* height: 16px; */
              /* top: 4.5px; */
            "
          />
          {{ this.$t("pages.FirmwareAdd.ChooseFile") }}
        </button>
      </div>

      <div class="col-sm-8">
        <input
          type="text"
          class="form-control txtAreaChoose"
          id="inputPassword"
          v-model="filename"
          readonly
          :placeholder="this.$t('pages.FirmwareAdd.ChooseFile')"
        />
        <div hidden>
          <input
            class="form-control"
            type="file"
            ref="file"
            @change="selectFile"
            style="font-style: italic"
            accept="application/x-zip-compressed"
          />
        </div>
      </div> -->
    </div>
    <div class="row">
      <div class="col-sm-1"></div>
      <div class="col-sm-10">
        <div
          class="d-grid gap-2 d-md-flex justify-content-md-end"
          style="margin-bottom: 10px"
        >
          <button
            class="btn btn-success2 me-md-2"
            type="button"
            id="Save"
            v-bind:style="
              !enableSend || !this.hasRole
                ? { 'background-color': 'gray!important' }
                : ''
            "
            @click.prevent="SendFile"
            :disabled="!enableSend || !this.hasRole"
          >
            {{ this.$t("common.save") }}
          </button>
          <button
            class="btn btn-warning"
            type="button"
            id="Reset"
            @click.prevent="cancel"
          >
            {{ this.$t("pages.FirmwareAdd.Reset") }}
          </button>
        </div>
      </div>
    </div>
    <!-- <p>
      ss{{
        this.$d(new Date(), {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
      }}
    </p> -->
    <div class="row">
      <div class="col-md-1"></div>
      <div class="col-md-10">
        <div class="progress">
          <div
            class="progress-bar progress-bar-striped"
            role="progressbar"
            v-bind:aria-valuenow="uploadPercentage"
            aria-valuemin="0"
            aria-valuemax="100"
            v-bind:style="{ width: uploadPercentage + '%' }"
          >
            {{ uploadPercentage }} %
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="margin-top: 40px">
      <div class="col-md-1"></div>
      <div class="col-md-10">
        <div v-if="errors && errors.length">
          <div v-for="error of errors" :key="error">
            <p
              class="alert alert-danger"
              role="alert"
              v-if="!this.isGenericError(error)"
            >
              {{ $t("pages.FirmwareAdd.ErrorLabel." + error) }}
            </p>
            <p class="alert alert-danger" role="alert" v-else>
              {{ $t("pages.FirmwareAdd.ErrorLabel.Error") }} {{ error }}
            </p>
          </div>
        </div>

        <p class="alert alert-success" role="alert" v-if="SuccesSend">
          {{ $t("pages.FirmwareAdd.SuccesSendMessage") }}
        </p>
      </div>
    </div>

    <div class="form-group row">
      <loaderSpinner :loading="isLoading"></loaderSpinner>
    </div>
  </main>
</template>

<script>
import { defineComponent } from "vue";
import MainService from "../services/MainService";
import LoaderSpinner from "../components/LoadingSpinner.vue";
import { version } from "../../package";
import ContentTitle from "@supervision/vue-components/components/ContentTile";
export default defineComponent({
  name: "FirmwareAdd",
  inject: ["accessToken"],
  components: {
    LoaderSpinner,
    ContentTitle,
  },
  watch: {
     currentScope(newVal) {
        if (newVal) {
          this.mainService = new MainService(this.$jwt.token, newVal);
        }
      },
      accessToken(newVal) {
        if (newVal) {
          this.mainService = new MainService(newVal, this.currentScope);
        }
      },
  },
  data() {
    return {
      hasRole: this.$jwt.hasAtLeastOneRole([
        "dm-administrator",
        "dm-ufw-write",
      ]),
      appVersion: version,
      mainService: new MainService(this.$jwt.token, this.$jwt.scope),
      currentScope: this.$jwt.scope,
      TooltipContent:
        '<div class="tooltipPortal"><div class="scf-help icon"><span class="tooltiptextPortal"><span class="title-tooltipPortal">' +
        this.$t("sideMenu.FirmwareAdd") +
        "</span></span></div></div>",
      formData: null,
      isLoading: false,
      enableSend: true,
      errors: [],
      file: null,
      filename: "",
      uploadPercentage: 0,
      SuccesSend: false,
    };
  },
  methods: {
    inputFileClickEvent() {
      console.log(this.appVersion);
      const elem = this.$refs.file;

      elem.click();
    },
    isGenericError(e) {
      return e.includes(".");
    },
    progressBar(progressEvent) {
      this.uploadPercentage = parseInt(
        Math.round((progressEvent.loaded / progressEvent.total) * 100)
      );
    },
    intialization() {
      (this.enableSend = false),
        (this.errors = []),
        (this.file = ""),
        (this.filename = ""),
        (this.uploadPercentage = 0),
        (this.SuccesSend = false);
    },
    //* *Initialize existed objects , get file content and prepare the formData to be sended
    selectFile() {
      this.intialization();
      this.file = this.$refs.file.files[0];

      this.formData = new FormData();
      this.formData.append("firwmareFile", this.file);
      if (this.file) {
        this.filename = this.file.name;
        this.isLoading = true;
        //* *check the file name validation with progress bar
        // this.mainService
        //   .validation(this.filename, this.progressBar)
        //   .then((response) => {
        //     console.log(response);
        //     if (
        //       typeof response.data.errors != "undefined" &&
        //       response.data.errors != null &&
        //       response.data.errors.length != null &&
        //       response.data.errors.length > 0
        //     ) {
        //       response.data.errors.forEach((element) => {
        //         this.errors.push(element);
        //       });
        //     } else {
        //       this.enableSend = true;
        //     }
        //   })
        //   .catch((error) => {
        //     this.uploadPercentage = 0;
        //     this.errors.push(error);
        //   })
        //   .finally(() => {
        //     this.isLoading = false;
        //   });

        //* disable actually the validation for test reason ..
        this.enableSend = true;
        this.isLoading = false;
      }
    },
    //* Re-initialize all objects when form is canceled
    cancel() {
      this.intialization();
      this.$refs.file.value = null;
    },
    SendFile() {
      this.file = this.$refs.file.files[0];
      if (this.file) {
        this.filename = this.file.name;
      }
      //* Send file to server with call back progress bar event
      this.mainService
        .Send(this.formData, this.progressBar)
        .then((response) => {
          if (
            typeof response.data.errors != "undefined" &&
            response.data.errors != null &&
            response.data.errors.length != null &&
            response.data.errors.length > 0
          ) {
            this.SuccesSend = false;
            response.data.errors.forEach((element) => {
              this.errors.push(element);
            });
          } else {
            this.SuccesSend = true;
          }
          this.enableSend = false;
        })
        .catch((error) => {
          this.errors.push(" (code " + error.response.status + ".)");
        });
      this.cancel();
    },
  },
});
</script>

<style lang="scss" scoped>
.custom-file-input-group {
  background: transparent;
  border: unset !important;
  padding: 0;
  margin-right: 10px;
}
.btn-primary2 {
  color: #030f40 !important;
  border-radius: 5px !important;
  background: #615e5e36 !important;
  display: flex !important;
  align-items: center !important;
  //  font-size: 12px !important;
  font-family: "D-DIN-700" !important;
  border: 0px;
  font-size: 14px !important;
  line-height: 24px !important;
  width: 100% !important;
  height: 38px !important;
  flex-direction: row !important;
  padding: 0px 5px !important;
}

.txtAreaChoose {
  font-family: D-DIN;
  /* border: 0px; */
  font-size: 14px;
  line-height: 24px;
  width: 100%;
  height: 38px;
}

// .addFirmwareBtn
// {
//   /* Texte */

// color: #030F40;
// width: 111px;
// height: 24px;

// font-family: 'D-DIN-700';
// font-style: normal;
// font-weight: 700;
// font-size: 12px;
// line-height: 24px;
// /* identical to box height, or 200% */

// display: flex;
// align-items: center;
// }

.btn-success2 {
  color: #fff !important;
  background-color: #9bcd41 !important;
  border-color: #9bcd41 !important;
  border-radius: 5px !important;
  font-size: 13px !important;
  align-items: center !important;
  width: 84px !important;
  height: 25px !important;
  justify-content: center !important;
  flex-direction: column !important;
  padding: 12px !important;
}
</style>

<style scoped src="../assets/css/firmwareAdd.css"></style>
